module.exports = __webpack_public_path__ + "img/Retailer_learning_two.18490b1d.png";